var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "181", height: "136", fill: "#B341D7" } }),
      _c("path", {
        attrs: {
          d: "M161.181 0H19.8188V59.5005C19.8188 92.3611 51.4641 119 90.5007 119C129.536 119 161.181 92.3611 161.181 59.5005V0Z",
          fill: "#D070E7",
        },
      }),
      _c("path", {
        attrs: {
          d: "M90.9001 11.98C64.8755 11.98 43.7786 30.3951 43.7786 53.1114C43.7786 75.8266 64.8755 94.2417 90.9001 94.2417C116.923 94.2417 138.02 75.8266 138.02 53.1114C138.02 30.3951 116.923 11.98 90.9001 11.98Z",
          fill: "#B341D7",
        },
      }),
      _c("path", {
        attrs: {
          d: "M90.5004 34.3423C79.6936 34.3423 70.9329 42.7455 70.9329 53.1112C70.9329 63.4763 79.6936 71.8792 90.5004 71.8792C101.307 71.8792 110.067 63.4763 110.067 53.1112C110.067 42.7455 101.307 34.3423 90.5004 34.3423Z",
          fill: "#D070E7",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }